(() => {
  const VERSION='2026-08-14.1';
  if(window.PBDesktopAuditUXV1?.version===VERSION)return;

  const ROOT_SELECTOR='[id^="PBUSBBoxCustomizer-"],[id^="PBStandaloneUSBCustomizer-"]';
  const MODAL_SELECTOR='.pb-photo-customizer__modal,.pb-usb-customizer__modal,.pb-standalone-usb-customizer__modal,[data-pb-customizer-modal]';
  const roots=[];
  const q=(r,s)=>r?.querySelector(s)||null;
  const qa=(r,s)=>r?[...r.querySelectorAll(s)]:[];
  const a=(r,s)=>q(r,`${s}.is-active`);
  const d=(r,s,k,f='')=>a(r,s)?.dataset?.[k]||f;

  let cfg={};
  try{cfg=JSON.parse(document.querySelector('[data-pb-logo-v3-config]')?.textContent||'{}')}catch{}

  const family=root=>root.id.startsWith('PBStandaloneUSBCustomizer-')?'standalone':'usb-box';
  const ctxFor=t=>t instanceof Element
    ?roots.find(x=>x.scope.contains(t)||x.root.contains(t))||null
    :null;

  const setLabel=(button,text)=>{
    if(!button)return;
    let el=q(button,':scope > .pb-usb-addon__price-label');
    if(!el){
      el=document.createElement('strong');
      el.className='pb-usb-addon__price-label';
      button.appendChild(el);
    }
    el.textContent=text||'';
    el.hidden=!text;
  };

  if(!document.getElementById('pb-desktop-audit-ux-v1-style')){
    const style=document.createElement('style');
    style.id='pb-desktop-audit-ux-v1-style';
    style.textContent=`
      .pb-photo-customizer__choice .pb-usb-addon__price-label,
      .pb-photo-customizer__choice [data-pb-v22-price]{
        font-size:1.3rem!important;
        line-height:1.2!important;
        font-weight:600!important
      }
      .pb-desktop-audit-standalone .pb-standalone-usb-box-addon__foil-grid{
        display:flex!important;
        flex-wrap:wrap!important;
        gap:.8rem!important;
        margin-top:.8rem!important
      }
      .pb-desktop-audit-standalone .pb-standalone-usb-box-addon__foil{
        width:5.8rem!important;
        height:5.8rem!important;
        min-height:5.8rem!important;
        padding:0!important;
        border-radius:50%!important;
        display:block!important;
        position:relative!important;
        overflow:hidden!important;
        background:var(--pb-audit-foil-color,transparent)!important
      }
      .pb-desktop-audit-standalone .pb-standalone-usb-box-addon__foil-swatch{display:none!important}
      .pb-desktop-audit-standalone .pb-standalone-usb-box-addon__foil>span:last-child{
        position:absolute!important;
        width:1px!important;
        height:1px!important;
        overflow:hidden!important;
        clip:rect(0,0,0,0)!important;
        white-space:nowrap!important
      }
      .pb-desktop-audit-standalone .pb-standalone-usb-box-addon__foil.is-active{
        outline:2px solid rgb(var(--color-foreground))!important;
        outline-offset:2px!important
      }
      .pb-desktop-audit-standalone [data-box-key="fitted"].pb-audit-does-not-fit{
        opacity:.52!important;
        cursor:not-allowed!important
      }
      .pb-desktop-audit-standalone [data-box-key="fitted"].pb-audit-does-not-fit img{
        filter:grayscale(.25)
      }
      @media(max-width:549px){
        .pb-desktop-audit-standalone .pb-standalone-usb-box-addon__foil{
          width:5.2rem!important;
          height:5.2rem!important;
          min-height:5.2rem!important
        }
      }
    `;
    document.head.appendChild(style);
  }

  const font=value=>({
    montserrat:'"Montserrat",sans-serif',
    alegreya:'"Alegreya",serif',
    'roboto-slab':'"Roboto Slab",serif',
    oswald:'"Oswald",sans-serif',
    'great-vibes':'"Great Vibes",cursive'
  }[String(value||'').toLowerCase()]||'"PB Goudy Stamp",Georgia,serif');

  const syncCommon=x=>{
    const fields=q(x.scope,'[data-pb-usb-engraving-fields]');
    if(fields){
      fields.hidden=!(
        d(x.scope,'[data-usb-engraving]','usbEngraving','no')==='yes' &&
        !a(x.scope,'[data-pb-logo="usb"]')
      );
    }

    qa(x.scope,'.pb-photo-customizer__field').forEach(field=>{
      const label=q(field,'label');
      const paragraph=q(field,'p');
      if(label&&paragraph&&String(label.textContent||'').toLowerCase().includes('engraving color')){
        paragraph.textContent='Engraving color is shown to approximate the finished result: crystal USB engraving appears white, while wooden USB engraving burns into the wood and appears dark brown/black.';
      }
    });

    const select=q(x.scope,'[data-pb-usb-engraving-font]');
    if(select){
      select.style.fontFamily=font(select.value);
      qa(select,'option').forEach(option=>option.style.fontFamily=font(option.value));
    }
  };

  const usableChoice=button=>{
    if(!button||button.disabled||button.hidden||button.getAttribute('aria-disabled')==='true')return false;
    return getComputedStyle(button).display!=='none';
  };

  const ensureStandaloneDefaults=x=>{
    if(d(x.scope,'[data-box-choice]','boxChoice','none')!=='add'||x.defaultingBox)return;

    const styleActive=a(x.scope,'[data-box-key]');
    const colorActive=a(x.scope,'[data-box-color]');
    if(styleActive&&colorActive)return;

    const style=styleActive||qa(x.scope,'[data-box-key]').find(usableChoice);
    const cream=q(x.scope,'[data-box-color="Cream"]');
    const color=colorActive||(usableChoice(cream)?cream:qa(x.scope,'[data-box-color]').find(usableChoice));
    if(!style&&!color)return;

    // Let the original standalone customizer own its state changes by invoking
    // the same buttons a customer would. Defaults are applied only when there is
    // no existing selection and are never re-applied over a customer's choice.
    x.defaultingBox=true;
    queueMicrotask(()=>{
      try{
        if(!a(x.scope,'[data-box-key]')&&usableChoice(style))style.click();
        if(!a(x.scope,'[data-box-color]')&&usableChoice(color))color.click();
      }finally{
        x.defaultingBox=false;
      }
    });
  };

  const syncStandalone=x=>{
    x.scope.classList.add('pb-desktop-audit-standalone');

    // Remove the helper from the rendered flow entirely; do not rely on CSS hiding.
    q(x.scope,'.pb-standalone-usb-box-addon__foil-helper-row')?.remove();

    const ribbon=q(x.scope,'[data-box-key="ribbon"]');
    const ribbonName=q(ribbon,':scope > span');
    if(ribbonName)ribbonName.textContent='USB Box with Ribbon';

    const grid=q(x.scope,'[data-pb-box-foil-colors]');
    if(grid){
      const field=grid.closest('.pb-photo-customizer__field');
      const label=q(field,':scope > label');
      if(label){
        let current=q(label,'[data-pb-audit-addon-foil-label]');
        if(!current){
          label.textContent='Foil color: ';
          current=document.createElement('strong');
          current.dataset.pbAuditAddonFoilLabel='';
          label.appendChild(current);
        }
        current.textContent=d(x.scope,'[data-box-foil-name]','boxFoilName','Shiny Gold');
      }
      qa(grid,'[data-box-foil-name]').forEach(button=>
        button.style.setProperty('--pb-audit-foil-color',button.dataset.boxFoilColor||'#d9bd6a')
      );
    }

    const hybridHandles=new Set([
      'maple-wood-and-crystal-usb-3-0-high-speed',
      'walnut-wood-and-crystal-usb-3-0-high-speed'
    ]);

    if(hybridHandles.has(String(cfg.productHandle||''))){
      const fitted=q(x.scope,'[data-box-key="fitted"]');
      if(fitted){
        fitted.hidden=false;
        fitted.disabled=true;
        fitted.setAttribute('aria-disabled','true');
        fitted.classList.remove('is-active');
        fitted.classList.add('pb-audit-does-not-fit');
        setLabel(fitted,'Does not fit this USB');
      }
    }

    ensureStandaloneDefaults(x);
  };

  const sync=x=>{
    syncCommon(x);
    if(x.family==='standalone')syncStandalone(x);
  };

  const schedule=x=>[0,30,80,180,360].forEach(ms=>setTimeout(()=>sync(x),ms));

  qa(document,ROOT_SELECTOR).forEach(root=>{
    const scope=q(root,MODAL_SELECTOR)||root;
    const x={root,scope,family:family(root),defaultingBox:false};
    roots.push(x);
    sync(x);
  });

  ['click','input','change'].forEach(name=>
    document.addEventListener(name,event=>{
      const x=ctxFor(event.target);
      if(x)schedule(x);
    },true)
  );

  window.PBDesktopAuditUXV1={
    version:VERSION,
    active:true,
    refresh:()=>roots.forEach(sync)
  };
})();
